var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-overview',{attrs:{"banners":_vm.banners}}),_vm._v(" "),_c('the-game-list'),_vm._v(" "),_c('the-entry',{attrs:{"data":_vm.entry}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }